import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CisBaseComponent } from './cis-base.component';
import { BrowserBackGuard } from 'cbc-shared-lib';
import { Sgkz001dComponent } from './pages/sgkz001d/sgkz001d.component';

const routes: Routes = [
  {
    path: '',
    component: CisBaseComponent,
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: 'sgkz001d', component: Sgkz001dComponent, canDeactivate: [BrowserBackGuard] },
    ]
  },
];

/**
 * 一般機能ルーティングモジュール
 * @export
 * @class CisBaseRoutingModule
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CisBaseRoutingModule { }
